module.exports = __webpack_public_path__ + "media/toolkits/line-middle-0e9a80f1.png";